import { NotificationState } from "./types";

export const INITINAL_STATE: NotificationState = {
  title: "",
  message: "",
  type: "success",
  visible: false,
};
